import React from "react";
import CustomerAccountView from "../views/accounts/CustomerAccountView";
import CustomerAddressView from "../views/addresses/CustomerAddressView";
import CustomerEmailView from "../views/emails/CustomerEmailView";
import CustomerPhoneView from "../views/phones/CustomerPhoneView";

const CustomerContact: React.FC = () => {
    return <div>
        <CustomerPhoneView />
        <CustomerAddressView />
        <CustomerEmailView />
        <CustomerAccountView />
    </div>;
};

export default CustomerContact;